export function isNumeric(val: any) {
  return !isNaN(parseFloat(val)) && isFinite(val);
}
